import api from "!../../../../../../../projects/wpytblock/compile-files/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../projects/wpytblock/compile-files/node_modules/css-loader/dist/cjs.js!../../../../../../../projects/wpytblock/compile-files/node_modules/sass-loader/dist/cjs.js!./YoutubeBlockPreview.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};